import {Radio} from 'antd'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext} from 'react'
import {course_status_options} from 'views/AppLocals/Course'
import {NullAsDefault} from 'views/Shared'
import {SelectWidget} from "../../../../AppLocals/custom/ReactSelectComponents";
import WorkspaceContext from "../../../WorkspaceContext";
import _ from "lodash";
import {LayoutContext} from "../../../../../components/layouts/Default/LayoutContext";

export const CourseFilter = ({
                                 owner_id,
                                 owner_type,
                                 defaultValue,
                                 academicYear,
                                 hideStatusFilter = false,
                                 value: filter = {
                                     status: undefined,
                                     academic_year: undefined,
                                     academic_field: undefined
                                 },
                                 onChange: setValues = NullAsDefault,
                             }) => {
    const t = useTranslate()
    const {organization} = useContext(WorkspaceContext)
    const {isLg} = useContext(LayoutContext)

    const handleChange = useCallback(
        (name, value) => {
            setValues({
                ...filter,
                [name]: value,
            })
        },
        [filter]
    )

    return (
        <div className="flex flex-col items-center gap-2 mt-2">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 w-full items-center">
                <div className="flex items-center gap-3">
                    <div className="text-sm text-color-400 italic whitespace-no-wrap">
                        {`${t('academic year')} : `}
                    </div>
                    <SelectWidget
                        className="w-full"
                        name={"academic_year"}
                        value={filter.academic_year || undefined}
                        allowClear={true}
                        disabled={!!academicYear}
                        placeholder={t('click to select')}
                        onChange={(value) => {
                            handleChange("academic_year", value)
                        }}
                        options={[
                            ..._.get(organization, 'workspace_settings.courses.groups.working_year_groups', [])
                        ].filter(e => e != null && e !== '')
                            .map(e => {
                                return {
                                    key: e,
                                    value: e,
                                    label: e,
                                }
                            })}
                    />
                </div>

                <div className="flex items-center gap-3">
                    <div className="text-sm text-color-400 italic whitespace-no-wrap">
                        {`${t('academic field')} : `}
                    </div>
                    <SelectWidget
                        className="w-full"
                        name={"academic_field"}
                        value={filter.academic_field || undefined}
                        allowClear={true}
                        disabled={!!academicYear}
                        placeholder={t('click to select')}
                        onChange={(value) => {
                            handleChange("academic_field", value)
                        }}
                        options={[
                            ..._.get(organization, 'workspace_settings.courses.groups.working_field_groups', [])
                        ].filter(e => e != null && e !== '')
                            .map(e => {
                                return {
                                    key: e,
                                    value: e,
                                    label: e,
                                }
                            })}
                    />
                </div>

            </div>
            {!hideStatusFilter && <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 w-full items-center">
                {
                    isLg && <div className="flex-1"/>
                }
                <Radio.Group
                    name="status"
                    optionType="button"
                    buttonStyle="solid"
                    className="flex items-center justify-end custom-radio-button w-full lg:w-auto"
                    onChange={(event) => {
                        const {name, value} = event.target
                        handleChange(name, value)
                    }}
                    value={filter.status || undefined}>
                    <Radio
                        className="px-3 text-sm"
                        value={undefined}>
                        {t('all')}
                    </Radio>
                    {[course_status_options.normal, course_status_options.closed].map(
                        ({label, value}) => (
                            <Radio
                                key={value}
                                className="px-3 text-sm"
                                value={String(value)}>
                                {t(label)}
                            </Radio>
                        )
                    )}
                </Radio.Group>
            </div>}

        </div>
    )
}

export default CourseFilter
